import { c as _c } from "react/compiler-runtime";
/**
 * Release version label (#900)
 * Shows "Version X.Y.Z" in footers on UAT and Production. Renders nothing
 * when the build has no release tag.
 */

import { getReleaseVersion } from '@/lib/release/version';
interface ReleaseVersionProps {
  className?: string;
}
export function ReleaseVersion(t0) {
  const $ = _c(3);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getReleaseVersion();
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const version = t2;
  if (!version) {
    return null;
  }
  const t3 = `text-muted-foreground ${className}`;
  let t4;
  if ($[1] !== t3) {
    t4 = <p className={t3} data-testid="release-version">Version {version}</p>;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  return t4;
}